import { fabric } from 'fabric';
import Vec2 from 'vec2';

import { SELECTION_CIRCLES } from '@common/constants';
import type { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface FabricState {
    canvas: fabric.Canvas;
    activeFreeDrawing: Vec2[];
    freeDrawMode: boolean;
    selectionCircles: SELECTION_CIRCLES;
    /**Helper variable to trigger zooming. Meant to be toggled not set. The change triggers a zooming in fabricCanvas.tsx by means of a useEffect */
    triggerZooming: boolean;
}

const initialState: FabricState = {
    canvas: new fabric.Canvas(null),
    activeFreeDrawing: [],
    freeDrawMode: false,
    selectionCircles: SELECTION_CIRCLES.FOR_NONE,
    triggerZooming: true,
};

const fabricSlice = createSlice({
    name: 'fabric',
    initialState,
    reducers: {
        updateCanvas: (state, action: PayloadAction<fabric.Canvas>) => {
            return {
                ...state,
                canvas: action.payload,
            };
        },
        updateActiveFreeDrawing: (state, action: PayloadAction<Vec2[]>) => {
            state.activeFreeDrawing = action.payload;
        },
        updateFreeDrawMode: (state, action: PayloadAction<boolean>) => {
            state.freeDrawMode = action.payload;
        },
        updateSelectionCircles: (state, action: PayloadAction<SELECTION_CIRCLES>) => {
            state.selectionCircles = action.payload;
        },
        toggleTriggerZooming: (state) => {
            state.triggerZooming = !state.triggerZooming;
        },
    },
});

export const selectFabricCanvas = ({ fabric }: RootState): fabric.Canvas => {
    return fabric.canvas;
};

export const selectActiveFreeDrawing = ({ fabric }: RootState): Vec2[] => {
    return fabric.activeFreeDrawing;
};

export const selectFreeDrawMode = ({ fabric }: RootState): boolean => {
    return fabric.freeDrawMode;
};

export const selectSelectionCircles = ({ fabric }: RootState): SELECTION_CIRCLES => {
    return fabric.selectionCircles;
};

export const selectTriggerZooming = ({ fabric }: RootState): boolean => {
    return fabric.triggerZooming;
};

export default fabricSlice.reducer;

export const {
    updateCanvas,
    updateActiveFreeDrawing,
    updateFreeDrawMode,
    updateSelectionCircles,
    toggleTriggerZooming,
} = fabricSlice.actions;
